import { gql } from "@apollo/client";

export const FETCH_CHAT_SETTINGS = gql`
    query Chat($id: ID!) {
        chat(id: $id) {
            id
            graphEnabled
            companyContextEnabled
            gptOnlyEnabled
            settings
        }
    }
`;